// Copyright (c) 2025 Audere, All Rights Reserved

export type AuthState = {
  email: string;
  name: string;
  picture: string | null;
  credentials: string;
  token: string;
  expires: string;
  organizationId: string;
  roles: string[];
  isLoggedOut?: boolean;
};

export interface PortalApiResult<T> {
  request_uid: string;
  method_id: string;
  response_code: string;
  output: T;
}

export interface LoginButtonProps {
  googleClientId: string;
  onAuthSuccess: (auth: AuthState) => void;
}

export interface GetRolesData {
  organizations: {
    [org_id: string]: {
      roles: string[];
    };
  };
}
export interface OpenIdAuthData {
  email: string;
  name: string;
  picture: string | null;
  api_token: string;
  api_token_valid_until: string;
}

export const HttpStatus = {
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  INTERNAL_SERVER_ERROR: 500,
} as const;
